import { ConfigProvider } from "antd";
import MainLayout from "./layout/MainLayout";
import antdTheme from "./theme/antdTheme";
import "./css/style.css";
import { RouterProvider } from "react-router-dom";
import routs from "src/router/routs";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "./queryClient";

import { store } from "src/atoms/authAtom";
import { Provider } from "jotai";
function App() {
  return (
    <ConfigProvider direction="rtl" theme={antdTheme}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <MainLayout>
            <RouterProvider router={routs} />
          </MainLayout>
        </QueryClientProvider>
      </Provider>
    </ConfigProvider>
  );
}

export default App;
